export const emartmall = {
  orders: {
    list: "/api/emartmall/order/list",
    scanOrderSuccess: "/api/emartmall/order/scan-order-success",
    getFailedOrder: "/api/emartmall/order/get-failed-order",
  },
};
export default emartmall;
